
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import RadioButton from '@/components/radio-button.vue';
  import PickerDate from '@/components/picker-date.vue';
	import{
		getSearchDate,
    nextDay
	}from "@/utils/index"
  import {
    orderSupportmemberOrderSupportStatistic
  } from "@/api/order"
  import {
    menberlevelList
  } from "@/utils/config"
  @Component({  
    name: '',
    components: {
      RadioButton,
      PageFooter,
      PickerDate
    }
  })

  export default class ProductList extends Vue {
    private radioType = 0
    private radioList = [
      {
        label: '已完成售后',
        value: 0
      }, {
        label: '进行中售后',
        value: 1
      }
    ]
    private menberlevel = null
    private menberlevelList:any = menberlevelList
    private keywords = ''
    private filterTime = ''
    private tablelist:any = []
    private tableloading = false
    private pageNo = 1;
    private pageSize = 10;
    private statisticalmsg:any = {}
    private mounted () {
      this.filterTime = [getSearchDate(2,false,-29)[0],getSearchDate(2)[0]].join('/')
    }
    activated () {
      this.getList()
    }


    private exportlist(){
      let url = location.origin + '/pc/orderSupport/memberOrderSupportStatisticExport'
      url += '?SupportState=' + (this.radioType||'')
      url += '&RoleGrade=' + (this.menberlevel||'')
      url += '&Keywords=' + (this.keywords||'')
      if (this.filterTime){
        var splitList = this.filterTime.split('/');
        url += '&StartTime=' + (splitList[0]||'')
        url += '&EndTime=' + (nextDay(splitList[1],1)||'')
      }
      window.open(url)
    }
    private lookdetail(row){
      this.$router.push({
        name:'memberstatistical_detail',
        query:{
          Id:row.Id||0,
          type:this.radioType+'',
          name:encodeURIComponent(row.Name||''),
          filterTime:this.filterTime
        }
      })
    }
    private changePage(e){
      this.pageNo = e
      this.getList()
    }
    private clearSearch(){
      this.menberlevel = null
      this.keywords = ''
      this.pageNo = 1
      if(this.radioType==0){
        this.filterTime = [getSearchDate(2,false,-29)[0],getSearchDate(2)[0]].join('/')
      }else{
        this.filterTime = ''
      }
      this.getList()
    }
    private changeradioType(){
      this.pageNo = 1
      if(this.radioType==0){
        this.filterTime = [getSearchDate(2,false,-29)[0],getSearchDate(2)[0]].join('/')
      }else{
        this.filterTime = ''
      }
      this.getList()
    }
    private doSearch(){
      this.pageNo = 1
      this.getList()
    }
    private async getList(){
      try{
        this.tableloading = true
        let data:any = {
          SupportState:this.radioType,
          RoleGrade:this.menberlevel,
          Keywords:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        
				if (this.filterTime && this.radioType !=3){
					var splitList = this.filterTime.split('/');
					data.StartTime = splitList[0];
					data.EndTime = splitList[1] ? (nextDay(splitList[1],1)) : '';
				}
        let res = await orderSupportmemberOrderSupportStatistic(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.statisticalmsg = res.Result
        }
      }finally{
        this.tableloading = false
      }
    }
  }
